import { provideSingleton, lazyInject } from './inversify';
import { ApiService } from './api_service';
import { ContextService } from './context_service';
import { DataService } from './data_service';
import { callbackify } from 'util';
import defaultRechte from '../../config/defaultRechte.json';

@provideSingleton(RechteService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service

export class RechteService {

    constructor() {
        this.loadDefaultRechte = this.loadDefaultRechte.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    private override = 1;
    private currentUser: string = null;
    private rechte_entities: Array<string> = ['entity_user', 'access', 'access_user', 'access_groups', 'group_index', 'group_items'];
    private rechte_data: any = {};

    hasRecht(recht: string) {
        // Nur vorübergehend ...
        // console.log('USER:', this.apiService.getUsername());
        if (this.apiService.getUsername() === 'admin') {
            // if (!recht.startsWith('projekt.antrag.')) {
            //     return true;
            // }
            return true;
        }
        let found = false;
        const rechte = this.contextService.get('rechte');
        // console.log('Rechte: ', rechte);
        if (rechte) {
            rechte.forEach((e: any) => {
                if (e['name'].indexOf(recht) >= 0) {
                    found = true;
                }
            });
        } else {
            // found = true; // Problematische Stelle
        }
        return found;
    }

    // *********************************************************************************************************************
    // ********************************************** LOAD UND SAVE ********************************************************
    // *********************************************************************************************************************

    loadRechte(callback: any) {
        this.apiService.call(
            'getRechte',
            { override: 1, module: 'etool_admin' },
            (json: string, suc: boolean) => {
                if (suc) {
                    let obj: any;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(json, e);
                    }
                    // console.log(obj);
                    this.contextService.set('rechte', obj['rechte_merged']);
                    this.currentUser = obj['user'];
                    // this.loadDefaultRechte();
                    callback();
                }
            }
        );
    }

    loadDefaultRechte() {
        if (defaultRechte) {
            const rechte = this.contextService.get('rechte');
            // console.log(defaultRechte, rechte);
            if (rechte) {
                defaultRechte.map((d: any) => {
                    const i = rechte.findIndex((r: any) => { return d.name === r.name; });
                    if (i < 0) {
                        rechte.push(d);
                    }
                });
                this.contextService.set('rechte', rechte);
            } else {
                this.contextService.set('rechte', defaultRechte);
            }
        }
    }

    getTableAccess(callback: (access: Array<any>) => void, forceRefresh?: boolean) {
        let access = this.contextService.get('tableAccess');
        if (!forceRefresh && access && Array.isArray(access)) {
            callback(access);
        } else {
            this.apiService.call(
                'getTableAccess',
                { override: 1 },
                (data: string, suc: boolean) => {
                    if (suc) {
                        access = [];
                        try {
                            access = JSON.parse(data);
                        } catch (e) {
                            console.error(data, e);
                        }
                        this.contextService.set('tableAccess', access);
                        callback(access);
                    }
                }
            );
        }
    }
    // ***************************************************************
    // Hier laden wir einfach mal ALLES was zu den Rechten gehört

    getRechteBasis(modul: string, callback: (rechteData: any) => void) {
        const rechteData: any = {};
        let loadCnt = 0;
        const length = this.rechte_entities.length;
        this.rechte_entities.forEach((ent: string) => {
            this.getRechteEntity(ent, modul, (data: Array<any>) => {
                // Bei den Gruppen die "internen" Gruppen ausblenden, wenn man nicht das Recht "system.internal.rechte".
                if (!this.hasRecht('system.internal.rechte') && ent === 'group_index') {
                    const dataNew: Array<any> = [];
                    data.map((r: any) => {
                        if (r.intern !== 1) {
                            dataNew.push(r);
                        }
                    });
                    data = dataNew;
                }
                rechteData[ent] = data;
                loadCnt++;
                if (loadCnt === length) {
                    rechteData.currentUser = this.currentUser;
                    callback(rechteData);
                }
            });
        });
    }

    getRechteEntity(entity: string, modul: string, callback: (data: Array<any>) => void) {
        this.dataService.loadDataForModul(
            entity,
            {},
            { resolve: true },
            modul,
            (result: any) => {
                this.rechte_data[entity] = result[entity];
                callback(result[entity]);
            }
        );
    }

    delAccessUser(tid: number, callback?: () => void) {
        this.dataService.delData(
            'access_user',
            'legacy',
            { tid },
            null,
            (res: any) => {
                // console.log(res);
                if (callback) {
                    callback();
                }
            }
        );
    }

    addAccessUser(access_id: number, name: string, callback?: () => void) {
        this.dataService.saveData(
            'access_user',
            { access_id, name },
            null,
            false,
            (res: boolean) => {
                // console.log(res);
                if (callback) {
                    callback();
                }
            },
            'legacy'
        );
    }

    delGroupUser(tid: number, group_tid: number, callback?: () => void) {
        if (this.hasDeleteGroupRecht(group_tid)) {
            this.dataService.delData(
                'group_items',
                'legacy',
                { tid },
                null,
                (res: any) => {
                    // console.log(res);
                    if (callback) {
                        callback();
                    }
                }
            );
        }
    }

    addGroupUser(group_tid: number, name: string, callback?: () => void) {
        this.dataService.saveData(
            'group_items',
            { group_tid, name },
            null,
            false,
            (res: boolean) => {
                // console.log(res);
                if (callback) {
                    callback();
                }
            },
            'legacy'
        );
    }

    delAccessGroups(tid: number, group_tid: number, callback?: () => void) {
        if (this.hasDeleteGroupRecht(group_tid)) {
            this.dataService.delData(
                'access_groups',
                'legacy',
                { tid },
                null,
                (res: any) => {
                    // console.log(res);
                    if (callback) {
                        callback();
                    }
                }
            );
        }
    }

    addAccessGroups(group_tid: number, access_id: number, callback?: () => void) {
        this.dataService.saveData(
            'access_groups',
            { group_tid, access_id },
            null,
            false,
            (res: boolean) => {
                // console.log(res);
                if (callback) {
                    callback();
                }
            },
            'legacy'
        );
    }

    saveUser(tid: number, pass: string, mail: string, callback?: () => void) {
        this.dataService.saveData(
            'entity_user',
            {
                tid,
                pass,
                Mail: mail
            },
            null,
            false,
            (res: boolean) => {
                // console.log(res);
                if (callback) {
                    callback();
                }
            },
            'legacy'
        );
    }

    hasDeleteGroupRecht(group_tid: number) {
        // Beim Löschen die "internen" Gruppen ablehnen, wenn man nicht das Recht "system.internal.rechte".
        if (this.hasRecht('system.internal.rechte')) {
            return true;
        } else {
            if (this.rechte_data && Array.isArray(this.rechte_data.group_index)) {
                const itm = this.rechte_data.group_index.find((i: any) => { return i.tid === group_tid; });
                if (itm && itm.intern !== 1) {
                    return true;
                }
            }
        }
        return false;
    }

    getUserEffctivRechte(user: string) {
        const rechte: Array<string> = [];
        const rechteBasis = this.rechte_data;
        if (Array.isArray(rechteBasis.access) &&
            Array.isArray(rechteBasis.group_items) &&
            Array.isArray(rechteBasis.access_groups) &&
            Array.isArray(rechteBasis.access_user)) {

            const rechteMap: any = {};

            rechteBasis.access_user.map((iau: any) => {
                if (iau.name === user) {
                    rechteMap[iau.access_id] = 1;
                }
            });

            rechteBasis.group_items.map((igi: any) => {
                if (igi.name === user) {
                    rechteBasis.access_groups.map((iag: any) => {
                        if (iag.group_tid === igi.group_tid) {
                            rechteMap[iag.access_id] = 1;
                        }
                    });
                }
            });

            Object.keys(rechteMap).sort().forEach((aName: string) => {
                const aFound = rechteBasis.access.find((a: any) => { return a.name === aName; });
                if (aFound) {
                    rechte.push(aFound.info ? aFound.info : aFound.name);
                }
            });
        }
        return rechte;
    }
}
